import {Component, Inject, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ApiBaseService} from "../../../../../../projects/vendors/src/lib/services/api-base.service";
import {OnGoingOrder} from "../../../../@domain/on-going-order";
import {ApiEnum} from "../../../../@application/enum/api.enum";
import {AlertService} from "../../../../../../projects/vendors/src/lib/services/alert.service";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
    selector: 'lib-order-delete-dialog',
    templateUrl: './order-delete-dialog.component.html',
    styleUrl: './order-delete-dialog.component.css',
    standalone: false
})
export class OrderDeleteDialogComponent implements OnInit {
  deleteOrderForm!: FormGroup;
  apiBaseService = inject(ApiBaseService)
  private alertService = inject(AlertService)

  constructor(@Inject(MAT_DIALOG_DATA) public data: OnGoingOrder,
              private dialogRef: MatDialogRef<OrderDeleteDialogComponent>) {
  }

  ngOnInit() {
    this.deleteOrderForm = new FormGroup({
      orderId: new FormControl(this.data.orderId, Validators.required),
      deleteReason: new FormControl(null, Validators.required),
    })
  }

  onDelete() {
    if (this.deleteOrderForm.valid) {
      this.apiBaseService.PATCH_API([ApiEnum.RestaurantModule, ApiEnum.Order, ApiEnum.Delete],
        this.deleteOrderForm.value, true, 'Order Deleted Successfully').subscribe({
        next: value => {
          this.dialogRef.close(value)
        },
        error: (err: HttpErrorResponse)  => {
          if (err.status === 403) {
            this.alertService.showInfo('Info','please use admin credentials to delete order');
          }
        }
      })
    } else {
      Object.values(this.deleteOrderForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true })
        }
      })
    }
  }
}
